import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ENDPOINTS = deepFreeze({
    UNIQUE_SOURCES: {
        URI: () => '/api/v1/spaces/{{spaceId}}/unique-sources',
        methods: ['get'],
    },
    ALL_SALES_CHART: {
        URI: () => '/api/v1/spaces/{{spaceId}}/all-sales-chart',
        methods: ['get'],
    },
    SUMMARY: {
        URI: () => '/api/v1/spaces/{{spaceId}}/producer-summary',
        methods: ['get'],
    },
    PRODUCT_DETAILS: {
        URI: () => '/api/v1/spaces/{{spaceId}}/producer-transactions-items',
        methods: ['get'],
    },
    TRANSACTIONS: {
        URI: () => '/api/v1/spaces/{{spaceId}}/producer-transactions',
        methods: ['get'],
    },
    FEATURE_BY_SOURCE_CHART: {
        URI: () => '/api/v1/spaces/{{spaceId}}/feature-by-source-chart',
        methods: ['get'],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
